import { Text } from "@/atoms";
import { cn } from "@/lib/utils";

type FieldLabelProps = {
  readonly value: string;
  readonly htmlFor: string;
  readonly id: string;
  readonly invalid?: boolean;
  readonly className?: string;
};

export default function FieldLabel({
  value,
  htmlFor,
  invalid,
  id,
  className,
}: FieldLabelProps): React.ReactElement {
  return (
    <Text
      className={cn(invalid ? "text-red" : "text-black", className)}
      component="label"
      htmlFor={htmlFor}
      id={id}
      text={value}
      variant="label"
    />
  );
}
